module.exports = __webpack_public_path__ + "static/media/antes100mg.82b6701d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-alambrico/antes100mg.png
// module id = 101
// module chunks = 0